import { useEffect, useState } from "react"
import cl from "./ValueText.module.css"
import gl from "../../../styles/Global.module.css";

import { useVariable } from "../../../hooks/useVariable"

const pow10 = [1, 10, 100, 1000, 10000, 100000, 1000000, 10000000];
const DEFAULT_DIGITS=1;

function roundValue(val, digits) {
    const num = Number(val);
    if (!Number.isFinite(num)) return '*';
    const mult = pow10[digits] || Math.pow(10, digits);
    return Math.round(num * mult) / mult;
}

const ValueText = ({props}) => {
    // const[value, setValue] = useState(NaN);
    let value = useVariable(props.varName);
    const digits = props.digits ?? DEFAULT_DIGITS;
    value = roundValue(value, digits);
  useEffect(()=>{
    
  }, [value])  
  return (
    <div className={cl.wrapper} ><span className={[cl.value_text, gl.noselect].join(" ")}>{props.name}{value} {props.meas}</span></div>
  )
}

export default ValueText